<template>
  <div class="replay-root">
    <RetakeHost />
    <RetakeSessionFinished />
    <RetakeFinishCard />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RetakeHost from './RetakeHost.vue'
import RetakeFinishCard from './RetakeFinishCard.vue'
import RetakeSessionFinished from './RetakeSessionFinished.vue'
import { hasReplayTicket } from '../../utils/replayTicket'

export default {
  components: {
    RetakeHost, RetakeFinishCard, RetakeSessionFinished,
  },
  data: () => ({ finishedPosted: false, hasVisitedEarlierSlide: false, restartedAtFirstSlide: false }),
  computed: {
    ...mapGetters('replay', { canUseReplay: 'isEnabled' }),
    ...mapGetters('replay', ['isReplayCopy']),
    ...mapGetters(['activeActivity']),
    ...mapGetters('slideProgress', ['isLastVisibleSlide', 'visibleSlides']),
    isReplayFrame() {
      return !!this.isReplayCopy
        && !!this.canUseReplay
        && hasReplayTicket(this.canUseReplay)
        && window.parent !== window
    },
    isReplayPositionReady() {
      return !!this.$store.state.presentation?.id
        && this.activeActivity?.id != null
        && (this.visibleSlides || []).length > 0
    },
    hasSingleSlide() {
      return (this.visibleSlides || []).length === 1
    },
    replayPosition() {
      return {
        isReplayFrame: this.isReplayFrame,
        isLast: !!this.isLastVisibleSlide,
        isReady: this.isReplayPositionReady,
      }
    },
    hasFinishedReplay() {
      return this.isReplayFrame
        && this.isReplayPositionReady
        && !!this.isLastVisibleSlide
        && (this.hasVisitedEarlierSlide || this.hasSingleSlide)
    },
  },
  watch: {
    replayPosition: {
      immediate: true,
      handler({ isReplayFrame, isLast, isReady }) {
        if (!isReplayFrame || !isReady) return
        if (!isLast) {
          this.hasVisitedEarlierSlide = true
          return
        }
        if (this.hasVisitedEarlierSlide || this.hasSingleSlide || this.restartedAtFirstSlide) return
        this.restartedAtFirstSlide = true
        window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}#1`)
        window.dispatchEvent(new PopStateEvent('popstate'))
      },
    },
    hasFinishedReplay: {
      immediate: true,
      handler(finished) {
        if (!finished || this.finishedPosted) return
        this.finishedPosted = true
        window.parent.postMessage({ type: 'aha-replay-finished' }, '*')
      },
    },
    '$route.params.id': function () {
      this.$store.commit('replay/resetSessionEnded')
    },
    // Presenting again starts a new session, so what the stopped one left behind no longer applies.
    '$store.state.presentation.presenting': function clearStoppedSession(isPresenting, wasPresenting) {
      if (isPresenting === true && wasPresenting === false) this.$store.commit('replay/resetSessionEnded')
    },
  },
}
</script>
